var map = {
	"./black-arrow-down-icon.png": "./src/assets/icons/black-arrow-down-icon.png",
	"./cards/amex.svg": "./src/assets/icons/cards/amex.svg",
	"./cards/cvv-icon.png": "./src/assets/icons/cards/cvv-icon.png",
	"./cards/discover.svg": "./src/assets/icons/cards/discover.svg",
	"./cards/jcb.svg": "./src/assets/icons/cards/jcb.svg",
	"./cards/mastercard.svg": "./src/assets/icons/cards/mastercard.svg",
	"./cards/unionpay.svg": "./src/assets/icons/cards/unionpay.svg",
	"./cards/visa.svg": "./src/assets/icons/cards/visa.svg",
	"./green-tick.png": "./src/assets/icons/green-tick.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";